<template>
  <div>
    <v-expansion-panels class="mb-4" variant="accordion">
      <v-expansion-panel v-for="(menuItem, idx) in menuItems" :key="idx" class="footer-expansion-panel" elevation="0">
        <v-expansion-panel-title class="footer-title" color="black">
          {{ menuItem.title }}
        </v-expansion-panel-title>

        <v-expansion-panel-text color="black50" class="wd-bg-black" eager>
          <v-list class="py-0 !wd-bg-black">
            <a v-for="(subItem, key) in menuItem.subItems" :key="key" class="item-link" :href="subItem.url" target="_blank">
              <v-list-item>
                <v-list-item-title class="wd-text-white">
                  {{ subItem.title }}
                </v-list-item-title>
              </v-list-item>
            </a>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="footer-context d-flex flex-wrap">
      <v-img class="download-app mr-2 my-2" max-width="164" cover src="@/assets/images/appdownload/app-store.svg?url" @click="downloadApp('ios')" />
      <v-img class="download-app" max-width="164" src="@/assets/images/appdownload/google-play.svg?url" @click="downloadApp('android')" />
    </div>
  </div>
</template>

<script lang="ts">
import tools from '@/mixin/tools'
import { useDownloadLinks } from '@/composition/useConst'

interface FooterSubItem {
  title: string
  url: string
}

interface FooterMenuItem {
  title: string
  subItems: FooterSubItem[]
}

export default {
  name: 'FooterMobile',
  mixins: [tools],
  props: {
    menuItems: { type: Array as () => FooterMenuItem[], default: () => [] },
  },
  setup() {
    const config = useRuntimeConfig()
    const { iosLink, androidLink } = useDownloadLinks()

    function downloadApp(appType: 'ios' | 'android') {
      let link = `${config.public.BASE_URL}/app`
      if (appType === 'ios') {
        link = iosLink.value
      } else if (appType === 'android') {
        link = androidLink.value
      }

      window.open(link)
    }

    return {
      downloadApp,
    }
  },
}
</script>

<style lang="scss" scoped>
.footer-expansion-panel {
  .footer-title {
    padding: 0;
    font-size: 17px;
  }
}
</style>
<style lang="scss">
.footer-expansion-panel {
  .v-expansion-panel-content {
    &__wrap {
      padding: 0 0 16px;
    }
  }
}
</style>
